(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alm-gift-by-recipient"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-alm-rx]').forEach(function(root){
    if (root.dataset.rxReady === 'true') return;
    root.dataset.rxReady = 'true';
    var frames = root.querySelectorAll('[data-rx-frame]');
    var items = root.querySelectorAll('[data-rx-index]');
    var capName = root.querySelector('[data-rx-caption-name]');
    var capCount = root.querySelector('[data-rx-caption-count]');
    var set = function(a){
      var i = a.dataset.rxIndex;
      frames.forEach(function(f){ f.classList.toggle('is-active', f.dataset.rxFrame === i); });
      items.forEach(function(b){ b.classList.toggle('is-active', b === a); });
      if (capName) capName.textContent = 'For ' + (a.dataset.rxName || '');
      if (capCount) capCount.textContent = a.dataset.rxCount || '';
    };
    items.forEach(function(a){
      a.addEventListener('mouseenter', function(){ set(a); });
      a.addEventListener('focus', function(){ set(a); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
